import React from 'react'
import loadable from '@loadable/component'
import usePostHook from '../../customHooks/usePostHook'
import APIS from '../../contants/Endpoints'
const AddCustomerComponent = loadable(() => import('../../components/Customer/AddCustomer'))
type Props = {}

const AddCustomer = (props: Props) => {
  const { isPostLoading, mutateAsync, postData } = usePostHook({ queryKey: ["customer"], navigateURL: "/customer" });

  const handleAddCustomer = async (values: any) => {
    const url = APIS.CUSTOMER;
    const formData = {
      name: values.title,
      address: values.address,
      contact_number: values?.phoneNumber,
      email: values?.email
    };
    try {
      const res = await mutateAsync({ url, formData });
      console.log(res);
    } catch (err) {
      console.error("Error creating customer:", err);
      // Optional: Add user feedback for the error
    }
  };

  return (
    <AddCustomerComponent handleAddCustomer={handleAddCustomer} />
  )
}

export default AddCustomer